<template>
  <div class="details-view order-detail">
    <cargo-left-right-resize
      :show-left="orderArr.length>1"
      :left-style="{ width: '15%',paddingTop:'10px' }"
      :right-style="{ width: '85%',}"
      style="min-height:100%"
    >
      <template slot="left">
        <el-card shadow="never">
          <div slot="header">
            <span>订单号</span>
          </div>
          <el-menu
            style="border:none"
            :default-active="orderUuid"
          >
            <el-menu-item
              v-for="item in orderArr"
              :key="item.uuid"
              :index="item.uuid"
              @click="handleOrderChange(item)"
            >
              <span slot="title">{{ item.poNo }}</span>
            </el-menu-item>
          </el-menu>
        </el-card>
      </template>
      <template
        slot="right"
      >
        <div class="main-content">
          <div
            v-show="!isLook"
            class="app-main-inner-row"
            style="padding-left: 0px;"
          >
            <div class="triggers">
              <el-button
                type="primary"
                @click="editBack"
              >取消</el-button>
              <el-button
                type="primary"
                @click="doSave"
              >保存</el-button>
            </div>
          </div>
          <div
            v-show="isLook"
            class="app-main-inner-row"
            style="padding-left: 0px;justify-content: space-between;"
          >
            <div class="triggers">
              <el-button
                type="success"
                @click="toBackList"
              >返回</el-button>
              <el-button
                v-if="orderState!==1 && orderState!==-1"
                type="primary"
                @click="showDetail(orderUuid,3)"
              >编辑</el-button>
              <el-button
                v-if="orderState!==1 && orderState!==-1"
                type="danger"
                @click="handleCancelOrder"
              >取消</el-button>
              <el-button
                v-if="orderState!==1"
                type="danger"
                :disabled="!$checkPermission(['button_OrderManage_delete'])"
                @click="handleDelOrder"
              >删除</el-button>
              <el-button
                v-if="orderState===-1"
                type="primary"
                :disabled="!$checkPermission(['button_OrderManage_renew'])"
                @click="handleRenewOrder"
              >恢复</el-button>
              <el-button
                v-if="orderState!==1 && orderState!==-1"
                type="primary"
                @click="packageImportVisible = true"
              >导入包装</el-button>
              <el-button
                v-if="orderState!==1 && orderState!==-1"
                type="primary"
                @click="handleSplitOrder"
              >拆单</el-button>
            </div>
            <div v-if="orderState!==null">
              <span v-if="orderState===-1">已取消</span>
              <span v-if="orderState===0">正操作</span>
              <span v-if="orderState===1">已完成</span>
            </div>
          </div>
          <div
            class="tabs-container"
            style="margin-top: 5px"
          >
            <el-tabs
              v-model="activeTabName"
              type="card"
              style="width:100%"
            >
              <el-tab-pane
                label="基础信息"
                name="basic"
              >
                <base-info
                  ref="baseInfo"
                  :order-uuid="orderUuid"
                  :opration-type="oprationType"
                />
              </el-tab-pane>
              <!--<el-tab-pane
                v-if="oprationType!==2"
                label="业务状态"
                name="businessStatus"
              >
                123
              </el-tab-pane>-->
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <import-dialog
      title="批量导入包装"
      :action="URL.order.importPoPackage"
      :visible="packageImportVisible"
      folder-name="booking"
      file-name="包装导入模板.xlsx"
      @onClose="packageImportVisible = false"
    />
  </div>
</template>
<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import baseInfo from './baseInfo'
import {
  savePoInfo,
  cancelPoInfo,
  deletePoInfo,
  splitPo, batchRenewPoInfo
} from '@/api/OMS/order'
import ImportDialog from './importDialog'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'OrderDetail',
  components: { cargoLeftRightResize, baseInfo, ImportDialog },
  data() {
    return {
      action: '',
      activeTabName: 'basic',
      orderUuid: '',
      orderArr: [],
      oprationType: 1,
      packageImportVisible: false,
      URL,
      orderState: null
    }
  },
  computed: {
    isLook() {
      return this.oprationType !== 2 && this.oprationType !== 3
    }
  },
  methods: {
    editBack() {
      if (this.orderUuid) {
        this.showDetail(this.orderUuid, 1)
      } else {
        this.toBackList()
      }
    },
    showDetail(uuid, oprationType, selectedRow) {
      if (uuid && typeof uuid !== 'string') {
        this.orderUuid = selectedRow ? selectedRow.uuid : uuid[0].uuid
        this.orderArr = uuid
        this.orderState = selectedRow ? selectedRow.state : uuid[0].state
      } else {
        this.orderUuid = uuid
      }
      this.oprationType = oprationType
    },
    handleOrderChange(order) {
      this.orderUuid = order.uuid
      this.orderState = order.state
    },
    toBackList() {
      this.orderUuid = ''
      this.orderArr = []
      this.$refs.baseInfo.$refs.form.resetFields()
      this.$emit('backList')
    },
    doSave() {
      const params = { ...this.$refs.baseInfo.form }
      if (!params.poNo.trim()) {
        this.$message.warning('订单号不能为空！')
        return
      }
      if (!params.customerId) {
        this.$message.warning('客户不能为空！')
        return
      }
      if (params.salesOffice !== 0 && !params.salesOffice) {
        this.$message.warning('销售公司不能为空！')
        return
      }
      if (params.salesDept !== 0 && !params.salesDept) {
        this.$message.warning('销售部门不能为空！')
        return
      }
      if (params.opOffice !== 0 && !params.opOffice) {
        this.$message.warning('操作公司不能为空！')
        return
      }
      if (params.opDepartment !== 0 && !params.opDepartment) {
        this.$message.warning('操作部门不能为空！')
        return
      }
      this.loading = getLoading()
      if (this.oprationType === 3) {
        params.uuid = this.orderUuid
      }
      if (params.seaEQ) {
        // 箱型箱量
        params.containerDesc = this.getSeaEqDesc(params)
        delete params.containers
        delete params.containerUsages
        delete params.seaEQ
      }
      savePoInfo(params)
        .then((res) => {
          this.$message.success('保存成功')
          this.loading.close()
          if (this.oprationType === 2) {
            this.orderUuid = res.data
          }
          this.oprationType = 1
        })
        .catch(() => {
          this.loading.close()
        })
    },
    handleCancelOrder() {
      const item = this.$refs.baseInfo.orderInfo
      let cancelInfo = ''
      if (new Date(item.atd) < new Date()) {
        cancelInfo = '此订单已离港，不可取消'
      } else if (item.jobNo) {
        cancelInfo = '此订单已有干线业务编号，不可取消'
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '订单号:'),
          h('span', { style: 'margin: 0 10px' }, item.poNo)
        ]),
        h('p', { style: 'color: red' }, cancelInfo || '是否确定取消此订单?')
      ])
      this.$confirm(content, '取消订单', {
        type: 'warning'
      }).then(() => {
        if (cancelInfo) {
          return
        }
        this.loading = getLoading()
        cancelPoInfo({ poInfoUuid: item.uuid })
          .then((res) => {
            this.$message.success('取消成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    handleDelOrder() {
      const item = this.$refs.baseInfo.orderInfo
      if (item.state !== -1) {
        this.$message.error('只有取消的订单才能删除')
        return
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '订单号:'),
          h('span', { style: 'margin: 0 10px' }, item.poNo)
        ]),
        h('p', { style: 'color: red' }, '是否确定删除此订单?')
      ])
      this.$confirm(content, '删除订单', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        deletePoInfo({ poInfoUuid: item.uuid })
          .then((res) => {
            this.$message.success('删除成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    handleRenewOrder() {
      const item = this.$refs.baseInfo.orderInfo
      if (item.state !== -1) {
        this.$message.error('只有取消的订单才能恢复')
        return
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('span', null, [
          h('p', null, '订单号:'),
          h('p', { style: 'overflow-wrap: break-word;' }, item.poNo)
        ]),
        h('p', { style: 'color: red' }, '是否确定订单恢复?')
      ])
      this.$confirm(content, '订单恢复', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const itemUuids = []
        itemUuids.push(item.uuid)
        batchRenewPoInfo({ poInfoUuids: itemUuids.join(',') })
          .then((res) => {
            this.$message.success('恢复成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    handleSplitOrder() {
      const item = this.$refs.baseInfo.orderInfo
      const packages = this.$refs.baseInfo.$refs.packageInfo.gridOptions.api
        .getSelectedRows()
        .filter((item) => {
          return item.packageNo
        })

      if (item.containerNo) {
        this.showSplitOrderError(
          '此订单已装箱，不可拆单；如需拆单，请先将此订单移出集装箱。'
        )
        return
      }
      if (packages.length === 0) {
        this.showSplitOrderError('请先勾选包装，才可进行拆单。')
        return
      }
      this.splitOrderSubmit(item, packages)
    },
    showSplitOrderError(err) {
      const h = this.$createElement
      const content = h('div', null, [
        h('p', { style: 'color: red' }, err),
        h(
          'p',
          { style: 'color: gray' },
          '拆单：是指将部分包装拆分到新的进仓通知单中，而其他信息复制过去。'
        )
      ])
      this.$confirm(content, '取消订单', {
        type: 'error'
      })
    },
    splitOrderSubmit(item, packages) {
      const packageNos = packages.map((item) => item.packageNo)
      const packageUuids = packages.map((item) => item.uuid)
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '包装号:'),
          h('p', { style: 'margin: 0 10px' }, packageNos.join(','))
        ]),
        h('p', { style: 'color: red' }, '注意:'),
        h('p', { style: 'color: red' }, '1、拆单后，包装号不变'),
        h(
          'p',
          { style: 'color: red' },
          '2、拆单后，系统会自动通过包装核算SKU数量，将包含的SKU带入到新订单中，被拆分订单SKU数量也会相应减少。'
        ),
        h(
          'p',
          { style: 'color: red' },
          '3、如此订单的包装是和其他订单混装在一起的，则拆单时，只替换包装中当前的订单号，被混装的订单号不会被修改。'
        ),
        h('p', { style: 'color: red' }, '4、此操作不可逆，请谨慎操作。')
      ])
      this.$confirm(content, '拆分订单', {
        type: 'info'
      }).then(() => {
        this.loading = getLoading()
        splitPo({
          poInfoUuid: item.uuid,
          splitPoPackageList: packageUuids
        })
          .then((res) => {
            this.$message.success('拆单成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    getSeaEqDesc(params) {
      let desc = ''
      for (const seq of params.seaEQ) {
        if (desc.length > 0) {
          desc += '\n'
        }
        desc += seq.eqQuantity + ' * ' + seq.eqSize + ' ' + seq.eqType + ' ' + (seq.soc ? 1 : 0)
      }
      return desc
    }
  }
}
</script>
